export const ADD_MODEL_SUCCESS = 'ADD_MODEL_SUCCESS';
export const FETCH_MODEL = 'FETCH_MODEL';
export const DELETE_MODEL_SUCCESS = 'DELETE_MODEL_SUCCESS';
export const EDIT_MODEL_SUCCESS = 'EDIT_MODEL_SUCCESS';
export const SET_SEARCH_MODEL = 'SET_SEARCH_MODEL';
export const CLEAR_SESSION = 'CLEAR_SESSION';
